<template>
  <v-container>
<v-row>
  <v-col cols="12" md="9">
    <component :is="currentComponent" class="my-4"/>
  </v-col>
  <v-col cols="12" md="3">

  </v-col>
</v-row>
  </v-container>
</template>

<script setup>
import { inject, onMounted, computed,defineAsyncComponent } from 'vue'
import { useRoute } from 'vue-router'


const route = useRoute();
const type = computed(() => route.params.type);
const updateDocumentHead = inject('updateDocumentHead');


const currentComponent = computed(() => {
  if (route.params.type) {
    return defineAsyncComponent(() => 
    import(`@/components/sites/objects/praxiswissen/${type.value}Index.vue`)
  );
  } else {
    return defineAsyncComponent(() => 
      import(`@/components/sites/objects/praxiswissen/PraxiswissenWall.vue`)
    );
  }
});


onMounted(async () => {
  const type = route.params.type;
  if(type == 'Prophylaxe'){
    updateDocumentHead(
      'TeamWaizmann | Praxiswissen Prophylaxe & Zahnzusatzversicherung',
      'TeamWaizmann | Praxiswissen Prophylaxe & Zahnzusatzversicherung'
    ) 
  }
  if(type == 'FehlendeZaehne'){
    updateDocumentHead(
      'TeamWaizmann | Praxiswissen Zahnzusatzversicherung & fehlende Zähne',
      'TeamWaizmann | Praxiswissen Zahnzusatzversicherung & fehlende Zähne'
    ) 
    
  }
  if(type == 'AngerateneBehandlung'){
    updateDocumentHead(
      'TeamWaizmann | Praxiswissen Zahnzusatzversicherung & angeratene Behandlung',
      'TeamWaizmann | Praxiswissen Zahnzusatzversicherung & angeratene Behandlung'
    ) 
  }


})
</script>